import Swal from "sweetalert2";

const confirmDeleteDialog = async (t, removeFn, id) => {
  const result = await Swal.fire({
    showCloseButton: true,
    showCancelButton: true,
    allowEscapeKey: true,
    title: t("deleteTitle"),
    text: t("deleteText"),
    icon: "warning",
    confirmButtonColor: "#dc3545",
    // cancelButtonColor: "#0d6efd",//"#01411c",
    cancelButtonColor: "#198754",//"#01411c",
    confirmButtonText: t("deleteConfirmButtonText"),
    cancelButtonText: t("deleteCancelButtonText"),
  });

  if (result.value) {
    await removeFn(id);
  }
};

export default confirmDeleteDialog;
